import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { List, X, Clock } from "@phosphor-icons/react";

function DesktopNav({ links, loc, utcTime }) {
  return (
    <div className="hidden md:flex items-center gap-2">
      {links.map((l) => (
        <Link
          key={l.path}
          to={l.path}
          className={`px-4 py-2 rounded-full text-xs font-medium transition-all duration-300 ${
            loc.pathname === l.path 
              ? "bg-indigo-500/10 text-indigo-400" 
              : "text-slate-400 hover:text-slate-200 hover:bg-slate-800/50"
          }`}
        >
          {l.name}
        </Link>
      ))}
      <div className="flex items-center gap-1.5 ml-4 pl-4 border-l border-slate-800 text-slate-400 font-mono text-xs">
        <Clock size={14} className="text-indigo-400" />
        {utcTime}
      </div>
      <a
        href="https://app.b3eye.com"
        data-testid="navbar-join-now"
        className="ml-4 px-5 py-2 rounded-full text-xs font-bold bg-gradient-to-r from-indigo-500 to-purple-600 text-white shadow-lg shadow-indigo-500/25 hover:from-indigo-400 hover:to-purple-500 hover:shadow-indigo-500/50 transition-all"
      >
        Join Now
      </a>
    </div>
  );
}

function MobileNav({ links, loc, open, setOpen, utcTime }) {
  return (
    <>
      <div className="md:hidden flex items-center gap-3">
        <div className="flex items-center gap-1.5 text-slate-400 font-mono text-[10px]">
          <Clock size={12} className="text-indigo-400" />
          {utcTime}
        </div>
        <a
          href="https://app.b3eye.com"
          data-testid="navbar-join-now-mobile"
          className="px-3 py-1.5 rounded-full text-[10px] font-bold bg-gradient-to-r from-indigo-500 to-purple-600 text-white"
        >
          Join Now
        </a>
        <button className="text-slate-300" onClick={() => setOpen(!open)}>
          {open ? <X size={24} /> : <List size={24} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden absolute top-16 left-0 w-full border-t border-slate-800 bg-slate-950 shadow-2xl">
          <div className="flex flex-col p-4 gap-2">
            {links.map((l) => (
              <Link
                key={l.path}
                to={l.path}
                onClick={() => setOpen(false)}
                className={`px-4 py-3 rounded-xl text-sm font-medium ${
                  loc.pathname === l.path ? "bg-indigo-500/10 text-indigo-400" : "text-slate-400"
                }`}
              >
                {l.name}
              </Link>
            ))}
            <a
              href="https://app.b3eye.com"
              onClick={() => setOpen(false)}
              className="mt-2 px-4 py-3 rounded-xl text-sm font-bold text-center bg-gradient-to-r from-indigo-500 to-purple-600 text-white"
            >
              Join Now
            </a>
          </div>
        </div>
      )}
    </>
  );
}

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  const [utcTime, setUtcTime] = useState("");

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      const h = now.getUTCHours().toString().padStart(2, "0");
      const m = now.getUTCMinutes().toString().padStart(2, "0");
      const s = now.getUTCSeconds().toString().padStart(2, "0");
      setUtcTime(`${h}:${m}:${s} UTC`);
    };
    updateTime();
    const id = setInterval(updateTime, 1000);
    return () => clearInterval(id);
  }, []);

  const links = [
    { name: "Home", path: "/" },
    { name: "Terminal", path: "/dashboard" },
    { name: "Arbitrage", path: "/bot/arbitrage" },
    { name: "Pump Sniper", path: "/bot/pump-migration" },
    { name: "AI Momentum", path: "/bot/ai-trade" },
    { name: "AI Synergy", path: "/bot/ai-combo" },
    { name: "Live Tape", path: "/tape" },
  ];

  return (
    <nav className="border-b border-slate-800 bg-slate-950/80 backdrop-blur-xl sticky top-0 z-50">
      <div className="max-w-[1500px] mx-auto px-4 md:px-8 h-16 flex items-center justify-between relative">
        <Link to="/" className="flex items-center group">
          <img
            src="/logo-white.png"
            alt="B3eye"
            className="h-8 w-auto transition-transform group-hover:scale-105"
          />
        </Link>

        <DesktopNav links={links} loc={loc} utcTime={utcTime} />
        <MobileNav links={links} loc={loc} open={open} setOpen={setOpen} utcTime={utcTime} />
      </div>
    </nav>
  );
}
